import { render } from "./FormPhotoRetioned.vue?vue&type=template&id=a35c5150"
import script from "./FormPhotoRetioned.vue?vue&type=script&lang=js"
export * from "./FormPhotoRetioned.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__